<template>
  <div class="content">
    <template>
      <v-card
        :style="$vuetify.breakpoint.xs
          ? 'margin: 4px'
          : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="!ready" />
        <div v-if="ready">
          <crud-list
            v-model="supervisores"
            :headers="headers"
            export-pdf-xlsx
            :slots="['item.telefones', 'item.tipo_supervisor', 'item.status']"
            :actions="actions"
            :show-expand="true"
            :permission="'list_supervisor'"
            :sort-by="['nome']"
            :sort-desc="[false]"
          >
            <template v-slot:expanded-item="{ item }">
              <td
                v-if="item.unidades"
                :colspan="headers.length"
              >
                <div>
                  <v-simple-table
                    dense
                    class="mb-5 mt-5"
                    style="border: 1px solid lightgrey; max-width: 85%;"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th
                            colspan="4"
                            class="black--text font-weight-black"
                          >
                            Unidades de negócio
                          </th>
                        </tr>
                        <tr>
                          <th>
                            CNPJ
                          </th>
                          <th>
                            Nome Fantasia
                          </th>
                          <th>
                            Código centro
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="unidades in item.unidades"
                          :key="unidades.nome_fantasia"
                        >
                          <td>{{ unidades.cnpj }}</td>
                          <td>{{ unidades.nome_fantasia }}</td>
                          <td>
                            {{ unidades.cod_centro }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>

                <div v-if="item.tecnicos.length">
                  <v-simple-table
                    dense
                    class="mb-5 mt-5"
                    style="border: 1px solid lightgrey; max-width: 85%;"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th
                            colspan="3"
                            class="black--text font-weight-black"
                          >
                            Técnicos Vinculados
                          </th>
                        </tr>
                        <tr>
                          <th style="width: 300px;">
                            CPF
                          </th>
                          <th>
                            Nome
                          </th>
                          <th style="padding-right: 500px;">
                            Telefones
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="tecnicos in item.tecnicos"
                          :key="tecnicos.nome"
                        >
                          <td>{{ tecnicos.cpf }}</td>
                          <td>
                            {{ tecnicos.nome }}
                          </td>
                          <td>
                            <div
                              v-for="(telefone, index) in tecnicos.telefones"
                              :key="index"
                            >
                              <span v-if="telefone">
                                {{ `${index + 1}: ${telefone}` }}
                                <br>
                              </span>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </td>
            </template>

            <template
              v-if="$store.getters.hasPermission('inserir_supervisor')"
              v-slot:btnCadastro
            >
              <v-col>
                <v-btn
                  block
                  class="text-none text-white"
                  color="primary"
                  title="Cadastrar novo Supervisor"
                  rounded
                  @click="$router.push({ path: 'supervisores/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
            <template v-slot:[`item.telefones`]="{ item }">
              <div
                v-for="(telefone, index) in item.telefones"
                :key="index"
              >
                <span v-if="telefone">
                  {{ `${index + 1}: ${telefone}` }}
                  <br>
                </span>
              </div>
            </template>
            <template v-slot:[`item.tipo_supervisor`]="{ item }">
              <span>
                {{ TipoSupervisor.getDescription(item.tipo_supervisor) }}
              </span>
            </template>
            <template
              v-slot:[`item.status`]="{ item }"
            >
              <v-checkbox
                v-model="item.status"
                class="mt-0"
                color="success"
                :loading="false"
                :readonly="!hasPermission('ativar_supervisor')"
                hint="Ativar/Desativar supervisor!"
                hide-details
                @change="TOGGLE_SUPERVISOR_STATUS(item)"
              />
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import SupervisorStore, { BOOTSTRAP, DELETE_SUPERVISOR, TOGGLE_SUPERVISOR_STATUS } from '@/store/modules/supervisores'
  import { mapState, mapActions } from 'vuex'
  import store from '@/store'
  import { TipoSupervisor } from '../../utils/constants'
  import { sortDateTime } from '../../utils/sorts'
  // import supervisores from '../../store/modules/supervisores'
  import JsPDF from 'jspdf'
  import moment from 'moment'
  import { mapGetters } from 'vuex/dist/vuex.common.js'

  export default {
    data () {
      return {
        search: '',
        TipoSupervisor,
        actions: [
          {
            title: 'Editar Supervisor',
            color: 'info darken-3',
            click: item => this.editarSupervisor(item),
            permission: 'editar_supervisor',
            icon: 'mdi-pencil',
          },
          {
            title: 'Excluir Supervisor',
            color: 'red darken-3',
            click: item => this.DELETE_SUPERVISOR(item),
            icon: 'mdi-trash-can-outline',
            permission: 'excluir_supervisor',
          },
          {
            title: 'Exportar para PDF',
            color: '#D50000',
            click: item => this.exportPDF(item),
            icon: 'mdi-file-pdf',
            permission: 'list_supervisor',
          },
        ].filter(action => store.getters.hasPermission(action.permission)),
        headers: [
          { text: '', value: 'data-table-expand', sortable: false, groupable: false, width: '10px' },
          { text: '', value: 'actions', sortable: false, groupable: false, width: '40px' },
          {
            align: 'left',
            sortable: true,
            groupable: false,
            text: 'Status',
            value: 'status',
            width: 'auto',
            floatingfilter: true,
            report: true,
            styleXLSX: { type: 'alterValue', alterValue: { 1: 'Ativo', 0: 'Inativo' } },
            styleReport: { alterValue: { 1: 'Ativo', 0: 'Inativo' } },
          },
          { align: 'left', sortable: true, groupable: false, text: 'CPF', value: 'cpf', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Nome', value: 'nome', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: false, groupable: false, text: 'Telefones', value: 'telefones', width: 'auto', report: true, styleXLSX: { type: 'telefone' } },
          { align: 'left', sortable: false, groupable: false, text: 'RG', value: 'rg', floatingfilter: true, width: 'auto' },
          { align: 'left', sortable: true, groupable: true, text: 'Papel', value: 'roles.description', floatingfilter: true, width: 'auto' },
          { align: 'left', sortable: true, groupable: true, text: 'Tipo de Supervisor', value: 'tipo_supervisor', floatingfilter: true, width: 'auto', enum: TipoSupervisor },
          { align: 'left', sortable: true, groupable: true, floatingfilter: true, text: 'Gerente', value: 'gestor.nome', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Email', value: 'email', width: 'auto', report: true },
          { align: 'center', sortable: true, groupable: false, text: 'Data de Nascimento', value: 'data_nascimento', width: 'auto', sort: sortDateTime },
          { align: 'left', sortable: true, groupable: true, text: 'Sexo', value: 'sexo', width: 'auto' },
        ],
      }
    },
    computed: {
      ...mapState('supervisores', ['ready', 'supervisores']),
      ...mapGetters(['hasPermission']),
    },
    async created () {
      if (!this.$store.hasModule('supervisores')) { this.$store.registerModule('supervisores', SupervisorStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('supervisores', [BOOTSTRAP, DELETE_SUPERVISOR, TOGGLE_SUPERVISOR_STATUS]),
      editarSupervisor ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/supervisores/alterar`,
          query: { id },
        })
      },

      async exportPDF (dados) {
        var doc = new JsPDF({
          orientation: 'portrait',
        })

        const docWidth = doc.internal.pageSize.width
        const docHeight = doc.internal.pageSize.height
        const logo = await loadImageAsBase64(window.location.origin + '/img/logo.png')

        const fontSize = 10
        const margin = { left: 10, right: 10, bottom: 10 }
        const dateNow = moment().format('DD/MM/YYYY')
        const horaNow = moment().format('HH:mm:ss')

        function addFooter (pageNumber) {
          doc.setFontSize(fontSize - 1)
          doc.text(dateNow, 10, docHeight - 10)
          doc.text('https://app.pioneiros.vet.br', docWidth / 2, docHeight - margin.bottom, { align: 'center' })
          doc.text('Página ' + pageNumber + ' / ' + totalPages, docWidth + 24, docHeight - 10, { align: 'right' })
        }

        function addHeader (name, logo, doc) {
          doc.addImage(logo, 'png', 10, 5, 38, 14)
          doc.setFontSize(16)
          doc.text(name, docWidth / 2, 15, { align: 'center' })
          doc.setFontSize(8)
          doc.text(dateNow, docWidth - 10, (15), { align: 'right' })
          doc.text(horaNow, docWidth - 10, (20), { align: 'right' })
        }

        async function loadImageAsBase64 (url) {
          const response = await fetch(url)
          const blob = await response.blob()

          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(blob)
          })
        }

        const addCabecalho = async () => {
          const bodySupervisorFormatado = {
            cpf: dados.cpf,
            nome: dados.nome,
            tipo_supervisor: dados.tipo_supervisor,
            telefone: (dados.telefones || [])
              .filter(tel => tel)
              .map((telefone, index) => `${index + 1}: ${telefone}`)
              .join(' | '),
          }

          doc.line(margin.left, 24, docWidth - margin.right, 24)
          doc.autoTable({
            theme: 'plain',
            startY: 25,
            margin: { left: margin.left },
            styles: {
              textColor: 20,
              fillColor: [255, 255, 255],
              cellPadding: { top: 0, right: 5, bottom: 0, left: 0 },
              fontSize: 10,
              minCellHeight: 5,
            },
            columnStyles: {
              0: {
                cellWidth: 'auto',
                halign: 'left',
                cellPadding: { left: margin.left },
              },
              1: {
                cellWidth: 'auto',
                halign: 'left',
                cellPadding: { left: 5 },
              },
            },
            body: [
              [
                { content: `Nome: ${bodySupervisorFormatado.nome}`, styles: { cellPadding: { left: 0 } } },
                { content: `CPF: ${bodySupervisorFormatado.cpf}` },
              ],
              [
                { content: `Tipo supervisor: ${TipoSupervisor.getDescription(bodySupervisorFormatado.tipo_supervisor)}`, styles: { cellPadding: { left: 0 } } },
                { content: `Telefone: ${bodySupervisorFormatado.telefone}` },
              ],
            ],
          })
        }

        var totalPages = '{total_pages_count_string}'

        const startYUnNeg = doc.previousAutoTable ? doc.previousAutoTable.finalY + 20 : 40
        doc.line(margin.left, startYUnNeg, docWidth - margin.right, startYUnNeg)
        doc.setFontSize(12)
        doc.text('Unidades de negócio', 105, startYUnNeg + 4, { align: 'center' })

        doc.autoTable({
          theme: 'plain',
          startY: startYUnNeg + 6,
          columnStyles: {
            cnpj: { cellWidth: 62 },
            nome_fantasia: { cellWidth: 66 },
            cod_centro: { cellWidth: 62 },
          },
          styles: {
            lineColor: [0, 0, 0],
            cellPadding: 0.5,
          },
          headStyles: { lineWidth: { top: 0.2, right: 0, bottom: 0.2, left: 0 } },
          columns: [
            { title: 'CNPJ', dataKey: 'cnpj' },
            { title: 'Nome fantasia', dataKey: 'nome_fantasia' },
            { title: 'Código centro', dataKey: 'cod_centro' },
          ],
          body: dados.unidades,

          didParseCell: function (data) {
            if (data.section === 'head' && data.row.index === 0) {
              data.cell.styles.fontStyle = 'bold'
            }
          },

          margin: { top: 43, left: 10, right: 10, bottom: 10 },
        })

        const startYTecVinc = doc.previousAutoTable ? doc.previousAutoTable.finalY + 20 : 40
        doc.line(margin.left, startYTecVinc - 14, docWidth - margin.right, startYTecVinc - 14)
        doc.setFontSize(12)

        doc.text('Técnicos vinculados', 105, startYTecVinc - 10, { align: 'center' })

        const bodyTecnico = Object.values(dados.tecnicos).map(tecnico => {
          return {
            cpf: tecnico.cpf,
            nome: tecnico.nome,
            telefone: (tecnico.telefones || [])
              .filter(tel => tel)
              .map((telefone, index) => `${index + 1}: ${telefone}`)
              .join(' | '),
          }
        })

        doc.autoTable({
          theme: 'plain',
          startY: startYTecVinc - 8,
          columnStyles: {
            cpf: { cellWidth: 30 },
            nome: { cellWidth: 80 },
            telefone: { cellWidth: 80 },
          },
          styles: {
            lineColor: [0, 0, 0],
            cellPadding: 0.5,
          },
          headStyles: { lineWidth: { top: 0.2, right: 0, bottom: 0.2, left: 0 } },
          columns: [
            { title: 'CPF', dataKey: 'cpf' },
            { title: 'Nome', dataKey: 'nome' },
            { title: 'Telefone', dataKey: 'telefone' },
          ],
          body: bodyTecnico,

          didParseCell: function (data) {
            if (data.section === 'head' && data.row.index === 0) {
              data.cell.styles.fontStyle = 'bold'
            }
          },
          margin: { top: 43, left: 10, right: 10, bottom: 10 },
          willDrawPage: () => {
            addCabecalho()
            addHeader('Vínculos do supervisor', logo, doc)
          },
          didDrawPage: (data) => {
            addFooter(data.pageNumber)
          },
        })

        doc.line(margin.left, doc.lastAutoTable.finalY, docWidth - margin.right, doc.lastAutoTable.finalY)
        let finalY = doc.lastAutoTable.finalY

        if (finalY > 150) {
          doc.addPage()
          addCabecalho()
          addHeader('Vínculos do supervisor', logo, doc)
          finalY = 43
          doc.line(margin.left, finalY, docWidth - margin.right, finalY)
        }

        if (typeof doc.putTotalPages === 'function') {
          doc.putTotalPages(totalPages)
        }
        doc.save('Vinculos do supervisor.pdf')
      },
    },
  }
</script>
